
<template>
  <div class="shop">
    <div class="content">
      <el-button class="add_button" type="primary" @click="handlerAdd"
        >新增</el-button
      >
      <!-- 表格封装 -->
      <my-eltable
        class="myTable"
        ref="mt"
        id="printTable"
        :tableData="tableData"
        :tabheight="tabheight"
        :tableHeader="tableHeader"
        :operateList="operateList"
        :loading="loading"
        :isshow="isshow"
        :total="total"
        @handlerTable="handlerModify"
        @handlerDelete="delClick"
        @handleRecive="handleRecive"
      ></my-eltable>
      <!-- 分页 -->
      <div class="fy">
        <el-pagination
          class="fx fend"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="sizes, prev, pager, next"
          :total="total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="isAdd">
      <el-form :model="shopInfo" ref="shopInfo" label-width="100px">
        <el-form-item label="店铺名称" prop="name">
          <el-input
            v-model="shopInfo.name"
            placeholder="请输入店铺名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="二级商户号" prop="name">
          <el-input
            v-model="shopInfo.splitMerchantId"
            placeholder="请输入二级商户号"
          ></el-input>
        </el-form-item>
        <el-form-item label="分账比例" prop="name">
          <el-input
            type="number"
            v-model="shopInfo.nhch"
            placeholder="请输入分账比例"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现手续费" prop="name">
          <el-input
            type="number"
            v-model="shopInfo.rate"
            placeholder="请输入提现手续费"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现银行卡号" prop="name">
          <el-input
            v-model="shopInfo.account"
            placeholder="请输入提现银行卡号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收款账户名" prop="name">
          <el-input
            v-model="shopInfo.accountName"
            placeholder="请输入收款账户名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="isModify"
            type="primary"
            @click="modifyForm('shopInfo')"
            >确认修改</el-button
          >
          <el-button v-else type="primary" @click="submitForm('shopInfo')"
            >立即创建</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="收款码" :visible.sync="reciveShow" width="60%">
      <vue-qr :text="recive" :margin="0" colorDark="#000" colorLight="#fff" :size="200"></vue-qr>
    </el-dialog>
  </div>
</template>

<script>
import { listPage, itemDelete, itemAdd, itemUpdate } from "@/http/api.js";
// 组件中引用
import MyEltable from "../../components/el_table";
import elMesBox from "../../components/el_message_box/Index";
import vueQr from 'vue-qr'
import { PAYMENT_URL } from '@/config'

export default {
  components: { MyEltable, elMesBox, vueQr },
  created() {
    this.listPage();
   
  },
  computed: {
  },
  data() {
    return {
      isAdd: false, //新增弹窗控制
      isModify: false, //修改弹窗控制

      shopInfo: {},
      timePeriod: [],
      name: "",
      content: "",
      contdate: "",
      value1: "",
      input: "",
      loading: false,
      isshow: true,
      tabheight: "100%",
      tableHeader: [
        // 表头
        // { prop: "id", label: "序号" },
        { prop: "name", label: "店铺名称" },
        { prop: "splitMerchantId", label: "二级商户号" },
        { prop: "nhch", label: "分账比例" },
        { prop: "rate", label: "提现手续费" },
        { prop: "accountName", label: "收款账户名" },
        { prop: "account", label: "收款卡号" },
      ],
      tableData: [],
      operateList: [
        { name: "修改", type: "primary", size: "mini", mark: 1 },
        { name: "删除", type: "danger", size: "mini", mark: 2 },
        { name: "收款码", type: "primary", size: "mini", mark: 3 },
      ],
      newdata: {
        name: "",
        content: "",
        contdate: "",
      },
      currentPage: 1,
      pagesize: 10,
      total: 0,
      recive: `${PAYMENT_URL}?id=`,
      reciveShow: false
    };
  },
  methods: {
    //生成收款码
    handleRecive(val){
      console.log(val.id)
      // let list = this.productcarList
      // let name = val.kioskName
      // var id;
      // list.forEach(item => {
      //   if(item.name == name){
      //     id = item.id
      //   }
      // })
      // console.log(id)
      this.recive = `${PAYMENT_URL}?id=${val.id}`
      this.reciveShow = true
    },
    // 点击新增
    handlerAdd() {
      this.isAdd = true;
      this.isModify = false;
      this.shopInfo = {};
    },

    // 新增售货亭
    submitForm() {
      console.log("this.shopInfo", this.shopInfo);
      this.shopInfo.nhch = Number(this.shopInfo.nhch);
      itemAdd(this.shopInfo).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          this.isAdd = false;
          this.listPage();
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 点击修改
    async handlerModify(val) {
      console.log("val", val);
      this.shopInfo = val;
      this.isAdd = true;
      this.isModify = true;
    },
    // 修改售货亭
    async modifyForm() {
      let res = await itemUpdate(this.shopInfo);
      console.log("res", res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "修改成功",
          type: "success",
        });
        this.isAdd = false;
        this.isModify = false;
        this.listPage();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
    // 获取售货亭列表
    async listPage() {
      console.log(localStorage.getItem("token"));
      let query = {
        page: this.currentPage + "",
        limit: this.pagesize + "",
      };
      let res = await listPage(query);
      console.log("res", res);
      this.tableData = res.data.list;
      this.total = res.data.totalCount;
    },

    //页码改变
    currentChange(val) {
      this.currentPage = val;
      this.listPage();
    },
    //handleSizeChange
    handleSizeChange(val) {
      this.pagesize = val;
      this.listPage();
    },

    //删除数据
    async delClick(val) {
      let query = [val.id];
      console.log("query", query);
      let res = await itemDelete(query);
      console.log("res", res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.listPage();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang='scss'>
// @import "../../common/css/qj_demo/index.css";

.shop {
  height: 100%;
  width: 100%;
  background: #f0f2f5;
  .content {
    width: 98%;
    // height: 900px;
    height: calc(100% - 37px);
    background: #ffffff;
    margin: 16px auto 0 ;
    padding: 10px;
  }
  .add_button {
    // margin-top: 10px;
    margin-bottom: 10px;
    color: #fff;
    background: #18b3a3;
    border: #18b3a3;
  }
  .add_button:hover {
    background: #18b3a3;
  }
}

.myTable {
  width: 100%;
  // margin-top: 24px;
  // margin-left: 40px;
}

.fy {
  width: 96%;
  margin: 10px auto 0;
}
.fend {
  justify-content: flex-end;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #18b3a3;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #18b3a3;
  color: #fff;
}
</style>